import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";

const InterestSurveyModal = () => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    interest: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const dontAsk = localStorage.getItem("dontAskSurvey");
    if (!dontAsk) {
      setTimeout(() => setShow(true), 10000); // Show after 10 seconds
    }
  }, []);

  const handleClose = () => setShow(false);

  const handleDontAskMe = () => {
    localStorage.setItem("dontAskSurvey", "true");
    setShow(false);
  };

  const handleRemindMeLater = () => {
    setShow(false);
    setTimeout(() => setShow(true), 60000); // Show again after 1 minute
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.interest.trim()) newErrors.interest = "Message is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://karstar.in/api/client_api/survey/index.php",
        formData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      console.log(response.data)

      if (response.data.status) {
        setSubmitted(true);
        setTimeout(() => setShow(false), 2000);
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting survey. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Interest Survey</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {submitted ? (
          <p className="text-success text-center">
            Survey submitted successfully!
          </p>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name:*</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleInputChange}
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Contact Number:*</Form.Label>
              <Form.Control
                type="tel"
                name="phone"
                placeholder="Enter your contact number"
                value={formData.phone}
                onChange={handleInputChange}
                isInvalid={!!errors.phone}
              />
              <Form.Control.Feedback type="invalid">
                {errors.phone}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Product Interested In:*</Form.Label>
              <Form.Control
                as="textarea"
                name="interest"
                rows={3}
                placeholder="Enter your message"
                value={formData.interest}
                onChange={handleInputChange}
                isInvalid={!!errors.interest}
              />
              <Form.Control.Feedback type="invalid">
                {errors.interest}
              </Form.Control.Feedback>
            </Form.Group>

            <div className="d-flex justify-content-between mb-3">
              <Button variant="link" className="text-dark" onClick={handleDontAskMe}>
                Don't Ask Me
              </Button>
              <Button variant="link" className="text-dark" onClick={handleRemindMeLater}>
                Remind Me Later
              </Button>
            </div>

            <div className="d-flex justify-content-center">
              <Button variant="outline-secondary" onClick={handleClose}>
                Close
              </Button>
              <Button type="submit" variant="primary" className="ms-2" disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default InterestSurveyModal;